import { Menu, Dropdown, Button, Row, Col } from 'antd';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
// import { useState } from 'react';
import '../styles.css';

function DefaultLayout(props) {
    
    const user = JSON.parse(localStorage.getItem('user'));
    // const [visible, setVisible] = useState(false);

    // const showDrawer = () => {
    //     setVisible(true);
    // };

    // const onClose = () => {
    //     setVisible(false);
    // };

    const menu = (
        <Menu>
            <Menu.Item>
                <a style={{color:'orangered'}} href="/home">
                    Home
                </a>
            </Menu.Item>
            <Menu.Item>
                <a style={{color:'orangered'}} href="/about">
                    About
                </a>
            </Menu.Item>
            <Menu.Item>
                <a style={{color:'orangered'}} href="/services">
                    Services
                </a>
            </Menu.Item>
            <Menu.Item>
                <a style={{color:'orangered'}} href="/contact">
                    Contact
                </a>
            </Menu.Item>

            <Menu.Item>
                <a style={{color:'orangered'}} href="/userbookings">
                    My-Bookings
                </a>
            </Menu.Item>

            <Menu.Item>
                <a style={{color:'orangered'}} href="/admin">
                    Admin
                </a>
            </Menu.Item>

            <Menu.Item onClick={()=>{
                localStorage.removeItem('user');
                window.location.href='/';
            }}>
                <a style={{color:'orangered'}}>Logout</a>
            </Menu.Item>
        </Menu>
    );

    return (
        <div>
            <div className="header bs1">
                <Row gutter={24} className='justify-center'>
                    <Col lg={20} sm={24} xs={24}>
                        <div className="d-flex justify-content-between">
                            <h1><b><Link to='/' style={{color:'orangered'}}>SmartCars</Link></b></h1>
                            {/* <h5 ><b><Link to='/about' style={{color:'orangered'}}>About</Link></b></h5> */}
                            {/* <h5 ><b><Link to='/services' style={{color:'orangered'}}>Services</Link></b></h5> */}
                            {/* <h5 ><b><Link to='/contact' style={{color:'orangered'}}>Contact</Link></b></h5> */}

                            {
                                user?.name && <Dropdown overlay={menu} placement="bottom">
                                    <Button><span>{user?.name}</span></Button>
                                </Dropdown>
                                // <NAvigator userLoggedIn={user?.name}/>
                            }

                            {/* <Button type="danger" onClick={showDrawer}>Menu
                                <FontAwesomeIcon icon="fa-solid fa-bars" />
                            </Button>

                            <Drawer title="Menu" style={{color:'orangered'}} placement="right" onClose={onClose} visible={visible}>
                                <p><Link to='/about' style={{color:'orangered'}}>About</Link></p>
                                <p><Link to='/services' style={{color:'orangered'}}>Services</Link></p>
                                <p><Link to='/contact' style={{color:'orangered'}}>Contact</Link></p>
                            </Drawer> */}
                        </div>
                    </Col>
                </Row>
        
            </div>
             
            <div className="content">
                {props.children}
            </div>

            {/* footer */}
            <div className="footer" style={{width: '100%'}}>
                <div className='p-3 justify-center'>
                    <Row gutter={24} >
                        <Col lg={8} sm={24} xs={24} >
                            <div className="footer-col first">

                                <h6><strong><u>About Smartcars</u></strong></h6>
                                <p>Smart cars Kenya is one of the fastest growing independent car hire business in the country. 
                                    With over 5 year’s experience, we are committed to providing you with the highest levels of customer service as described in our <span><i>services-section</i></span>.
                                </p>
                    
                                <h6 className="newsletter"><strong><u>Newsletter</u></strong></h6>
                                <p>SIGN UP FOR OUR NEWSLETTER</p>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control p-2" placeholder="Enter Email" aria-label="Recipient's email" />
                                    <button className="btn-secondary news">
                                        <FontAwesomeIcon icon={faEnvelope} size="2x" className='me-2'/>
                                        {/* <FontAwesomeIcon icon={['fab', 'fa-modx' ]} size="lg" /> */}
                                    </button>       
                                </div>
                        
                            </div>
                        </Col>

                        <Col lg={8} sm={24} xs={24}>
                            <div className="footer-col second">
                                <h6><strong><u>Quick Links</u></strong></h6>

                                <ul className="list-unstyled li-space-lg p-small">
                                    <li>
                                        <a className='links' href="/services"> Services</a>
                                    </li>

                                    <li>
                                        <a className='links' href="/contact">Contact-Us</a>
                                    </li>
                                    <li>
                                        <a className='links' href="/terms">Terms & Conditions</a>
                                    </li>
                                    <li>
                                        <a className='links' href="/privacy">Privacy</a>
                                    </li>
                                </ul>
                                
                                <div className="pt-5">
                                    {/* <FontAwesomeIcon icon={['far', 'faClock' ]} size="3x" /> */}
                                    <FontAwesomeIcon icon={faClock} size="6x" style={{color: 'white'}}/>
                                    
                                </div>

                                <div className="ms-2">
                                    <h6><strong><u>Opening Hours</u></strong></h6>
                                    <p className='time'>Mon - Fri: 08:00 AM - 18:00 PM</p>
                                    <p className='time'>Sat: 09:00 AM - 12:00 PM</p>
                                    <p className='time'>Sunday - Closed</p>

                                </div>
                        
                            </div>
                        </Col>

                        <Col lg={8} sm={24} xs={24}>
                            <div className="footer-col third">

                                <h6 style={{display: 'flex', justifyContent: 'center'}}><strong>Follow Us On :</strong></h6>

                                <span className="fa-stack">
                                    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                                        <FontAwesomeIcon icon="fa-brands fa-facebook" size="6x" />
                                    </a>
                                </span>

                                <span className="fa-stack">
                                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                                        <FontAwesomeIcon icon="fa-brands fa-twitter" size="6x"/>
                                    </a>
                                </span>
        
                                <span className="fa-stack">
                                    <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                                        <FontAwesomeIcon icon="fa-brands fa-instagram" size="6x"/>
                                    </a>
                                </span>

                                <div className="mt-5">
                                    <h6 style={{display: 'flex', justifyContent: 'center'}}><strong><u>Payment Details</u></strong></h6>

                                    <p className='p-small2'>Our payment options are as below; <br />
                                        Cash - Mpesa-Till No. 00000 <br />
                                        Card - We accept all card payments made to Smart Cars-Ke.
                                    </p>
                                </div>
                                
                            </div> 
                        </Col>
                    </Row>
                </div>
            </div> 

            {/* Copyright */}
            <div className="copyright">
                <div className='justify-center'>
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="p-small">Copyright. SmartCars &copy;2022.</p>
                            <p className="p-small">Designed and Developed By <a style={{color: 'orangered'}} href="https://morys0.netlify.app/" target="_blank" rel="noopener noreferrer"><strong>Mo-Tech Solutions</strong></a></p>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    );
}

export default DefaultLayout;